import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import { API } from "@/config/api";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Methodology from "./components/Methodology";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AuthCallback from "./components/AuthCallback";
import { Toaster } from "./components/ui/sonner";

// Chatbot deshabilitado — pendiente de pruebas en preproducción
// import ChatbotButton from "./components/ChatbotButton";
// import ChatbotSheet from "./components/ChatbotSheet";

const LandingPage = () => {
  const [appConfig, setAppConfig] = useState(null);
  const [cvConfig, setCvConfig] = useState(null);
  const [contentConfig, setContentConfig] = useState(null);

  useEffect(() => {
    const fetchConfigs = async () => {
      try {
        const [appRes, cvRes, contentRes] = await Promise.all([
          axios.get(`${API}/config/app`),
          axios.get(`${API}/config/cv`),
          axios.get(`${API}/config/content`),
        ]);
        setAppConfig(appRes.data);
        setCvConfig(cvRes.data);
        setContentConfig(contentRes.data);
      } catch (e) {
        console.error("Error fetching configs:", e);
      }
    };
    fetchConfigs();
  }, []);

  return (
    <div className="min-h-screen bg-slate-900" data-testid="landing-page">
      <Header config={appConfig} />
      <main>
        <Hero content={contentConfig?.hero} />
        <Services content={contentConfig?.services} />
        <Methodology content={contentConfig?.methodology} />
        <About config={cvConfig} cpiicm={appConfig?.cpiicm} content={contentConfig?.about} />
        <Contact config={appConfig} content={contentConfig?.contact} />
      </main>
      <Footer config={appConfig} content={contentConfig?.footer} />
      {/* ChatbotButton deshabilitado — habilitar en preproducción para pruebas */}
      {/* <ChatbotButton onClick={() => setIsChatOpen(true)} /> */}
      {/* <ChatbotSheet isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} content={contentConfig?.chatbot} /> */}
      <Toaster position="top-right" />
    </div>
  );
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="*" element={<LandingPage />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
